import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule),
    // canActivate: [AuthGuard],
    // data : {
    //   module : 'loginPage'
    // }
  },
  {
    path: 'cce-expeirment',
    loadChildren: () => import('./cce-expeirment/cce-expeirment.module').then( m => m.CceExpeirmentPageModule),
    canActivate: [AuthGuard],
    data : {
      module : 'cce-expeirment'
    }
  },
  {
    path: 'cce-user',
    loadChildren: () => import('./cce-user/cce-user.module').then( m => m.CceUserPageModule),
    canActivate: [AuthGuard],
    data : {
      module : 'cce-user'
    }
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then( m => m.DashboardPageModule),
    canActivate: [AuthGuard],
    data : {
      module : 'dashboard'
    }
  },
  {
    path: 'cce-scheduling',
    loadChildren: () => import('./cce-scheduling/cce-scheduling.module').then( m => m.CceSchedulingPageModule),
    canActivate: [AuthGuard],
    data : {
      module : 'cce-scheduling'
    }
  },
  
  {
    path: 'cce-activity',
    loadChildren: () => import('./cce-activity/cce-activity.module').then( m => m.CceActivityPageModule),
    data : {
      module : 'cce-activity'
    }
  },
  
  {
    path: 'dashboarddetailsview',
    loadChildren: () => import('./dashboarddetailsview/dashboarddetailsview.module').then( m => m.DashboarddetailsviewPageModule)
  },
 
  {
    path: 'viewccefarmerdetails',
    loadChildren: () => import('./viewccefarmerdetails/viewccefarmerdetails.module').then( m => m.ViewccefarmerdetailsPageModule)
  },
  {
    path: 'viewccefarmdetails',
    loadChildren: () => import('./viewccefarmdetails/viewccefarmdetails.module').then( m => m.ViewccefarmdetailsPageModule)
  },
  {
    path: 'viewccedetails',
    loadChildren: () => import('./viewccedetails/viewccedetails.module').then( m => m.ViewccedetailsPageModule)
  },
  {
    path: 'cce-video',
    loadChildren: () => import('./cce-video/cce-video.module').then( m => m.CceVideoPageModule)
  },
  {
    path: 'userregistration',
    loadChildren: () => import('./userregistration/userregistration.module').then( m => m.UserregistrationPageModule),
    canActivate: [AuthGuard],
    data : {
      module : 'userregistration'
    }
  },
  {
    path: 'usermodulemaster',
    loadChildren: () => import('./usermodulemaster/usermodulemaster.module').then( m => m.UsermodulemasterPageModule),
    canActivate: [AuthGuard],
    data : {
      module : 'usermodulemaster'
    }
  },
  {
    path: 'experiment-upload',
    loadChildren: () => import('./experiment-upload/experiment-upload.module').then( m => m.ExperimentUploadPageModule),
    canActivate: [AuthGuard],
    data: {
      module: 'experiment-upload'
    }
  },  
  {
    path: 'usermodulemap',
    loadChildren: () => import('./usermodulemap/usermodulemap.module').then( m => m.UsermodulemapPageModule)
  },
  {
    path: 'cce-add-user',
    loadChildren: () => import('./cce-add-user/cce-add-user.module').then( m => m.CceAddUserPageModule)
  },
  {
    path: 'cce-edit-user',
    loadChildren: () => import('./cce-edit-user/cce-edit-user.module').then( m => m.CceEditUserPageModule)
  },
  {
    path: 'welcome-page',
    loadChildren: () => import('./welcome-page/welcome-page.module').then( m => m.WelcomePagePageModule),
    canActivate: [AuthGuard],
    data : {
      module : 'welcome-page'
    }
  },
  {
    path: 'downloadexcel',
    loadChildren: () => import('./downloadexcel/downloadexcel.module').then( m => m.DownloadexcelPageModule)
  },
  {
    path: 'ccecommentspopup',
    loadChildren: () => import('./ccecommentspopup/ccecommentspopup.module').then( m => m.CcecommentspopupPageModule)
  },
  {
    path: '**',
    loadChildren: () => import('./error/error.module').then( m => m.ErrorPageModule)
  },
  {
    path: 'viewstatus',
    loadChildren: () => import('./viewstatus/viewstatus.module').then( m => m.ViewstatusPageModule)
  },
  

  

  

  // {
  //   path: 'update-experiment-details',
  //   loadChildren: () => import('./update-experiment-details/update-experiment-details.module').then( m => m.UpdateExperimentDetailsPageModule)
  // },
  // {
  //   path: 'updateuserdetails',
  //   loadChildren: () => import('./updateuserdetails/updateuserdetails.module').then( m => m.UpdateuserdetailsPageModule)
  // },


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
